import HostWizard from './HostWizard';
import Audits from './Audits';
import Models from './Models';
import HostDetails from './HostDetails';
import RegistrationCommands from './RegistrationCommands';

export const routes = [
  HostWizard,
  Audits,
  Models,
  HostDetails,
  RegistrationCommands,
];



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/routes/routes.js